// extracted by mini-css-extract-plugin
export var skipAnimation = "_1s-0";